import { REACT_APP_HOST_BACKEND } from "../utils/hostBe";

const windowType: any = { ...window };
const windowEnv = windowType._env_;

const REACT_APP_BASENAME = windowEnv
  ? windowEnv.REACT_APP_BASENAME
  : process.env.REACT_APP_BASENAME;
const REACT_APP_PDT = windowEnv
  ? windowEnv.REACT_APP_PDT
  : process.env.REACT_APP_PDT;
const REACT_APP_PDA = windowEnv
  ? windowEnv.REACT_APP_PDA
  : process.env.REACT_APP_PDA;
const REACT_APP_NPDA = windowEnv
  ? windowEnv.REACT_APP_NPDA
  : process.env.REACT_APP_NPDA;

const REACT_APP_BASE_MS_GW_API = REACT_APP_HOST_BACKEND;

export {
  REACT_APP_BASENAME,
  REACT_APP_BASE_MS_GW_API,
  REACT_APP_PDT,
  REACT_APP_PDA,
  REACT_APP_NPDA
};
